import clsx from 'clsx';
import React from 'react';
import styles from './NumberedStepper.module.scss';
export const NumberedStepper = ({ activeStep, steps }) => (<div className={styles.numberedStepper}>
    {[...Array(steps).keys()].map((step) => (<span key={step} className={clsx(styles.step, step < activeStep && styles.complete, step === activeStep && styles.active)}>
        {step + 1}
      </span>))}
  </div>);
